import React from "react";
import { useNavigate } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import Logo from "../assets/logo.svg";

interface MobileMenuProps {
  setMobileMenu: (value: boolean) => void;
  mobileMenu: boolean;
  handleMenuClick: (menu: string) => void;
  selectedMenu: string;
}

const MobileMenu: React.FC<MobileMenuProps> = ({
  setMobileMenu,
  mobileMenu,
  handleMenuClick,
  selectedMenu,
}) => {
  const navigate = useNavigate();

  // Menu items with their routes
  const menuItems = [
    { label: "vendors", path: "/vendors" },
    { label: "clients", path: "/clients" },
    { label: "timesheet", path: "/timesheet" },
    { label: "timesheet approval", path: "/approval" },
  ];

  // Handle navigation and menu close
  const handleNavigation = (item: any) => {
    navigate(item.path);
    setMobileMenu(false);
    handleMenuClick(item.label);
  };

  if (!mobileMenu) return null;

  return (
    <div className="fixed inset-0 bg-white z-50 min-h-screen">
      <div className="p-4">
        {/* Header with logo and close button */}
        <div className="flex items-center justify-between mb-8">
          <div className="flex-shrink-0">
            <img src={Logo} alt="Design Hinge" />
          </div>
          <button onClick={() => setMobileMenu(false)} className="p-2">
            <IoClose size={24} />
          </button>
        </div>

        {/* Navigation Menu */}
        <nav>
          <ul className="space-y-2">
            {menuItems.map((item) => (
              <li key={item.path}>
                <button
                  onClick={() => handleNavigation(item)}
                  className={`text-xl font-semibold text-black hover:text-gray-600 p-2 rounded-md w-full text-left capitalize ${
                    selectedMenu == item.label
                      ? "bg-customGreen-bg text-customGreen-text"
                      : ""
                  }`}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;
